import React from "react";

const Header = () => {
  return (
    <div>
      <h1 style={{ color: "white" }}>Cybersoft Movie</h1>
    </div>
  );
};

export default Header;
